import React from 'react';
import { ctaLink } from '../data/mock';

const TheShiftSection = () => {
  const handleCTAClick = () => {
    if (window.fbq) {
      window.fbq('track', 'Subscribe');
    }
  };

  return (
    <section className="bg-[#F8F8F8] py-[50px] px-[25px] md:py-[75px] md:px-[75px] lg:py-[100px] lg:px-[100px]">
      <div className="max-w-5xl mx-auto">
        {/* Main Headline - "Boleh" in Pink */}
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-[#191919] text-center mb-8 tracking-tight leading-tight">
          Apa Fira Smart Desk <span className="text-[#FF6699]">Boleh</span> Buat
        </h2>

        {/* Main Point - Pink Box, White Text, No Icon, Bombastic */}
        <div className="bg-[#FF6699] rounded-2xl p-8 md:p-12 lg:p-16 mb-16 shadow-2xl transform hover:scale-[1.02] transition-all duration-300">
          <p className="text-2xl md:text-4xl lg:text-5xl text-[#F8F8F8] font-black text-center tracking-tight leading-tight">
            Bagi anda edge yang anda takda sekarang.
          </p>
        </div>

        {/* Explanation */}
        <div className="text-center space-y-4 mb-20">
          <p className="text-xl md:text-2xl text-[#191919]/70 font-medium">
            Bukan edge "lebih pandai dari market."
          </p>
          <p className="text-2xl md:text-3xl text-[#191919] font-bold">
            Tapi edge "tak perlu figure out semua sorang-sorang."
          </p>
        </div>

        {/* Divider */}
        <div className="flex justify-center mb-16">
          <div className="w-32 h-1 bg-[#FF6699]" />
        </div>

        {/* Feature 1: Signal - With Border */}
        <div className="mb-12 border-2 border-[#191919]/10 rounded-3xl p-6 md:p-10 lg:p-12 hover:border-[#FF6699]/30 transition-all duration-300">
          <h3 className="text-3xl md:text-4xl lg:text-5xl font-black text-[#191919] text-center mb-12 tracking-tight">
            Signal Yang Ada <span className="text-[#FF6699]">"Kenapa"</span>
          </h3>
          
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Phone Mockup - AI Signal CROP - Bottom padding 0 */}
            <div className="flex justify-center">
              <div className="border-2 border-[#191919]/10 rounded-3xl pt-4 px-4 pb-0 bg-[#191919]/5 overflow-hidden">
                <img 
                  src="https://customer-assets.emergentagent.com/job_618cd302-26c2-4845-b940-fc1c769b2643/artifacts/kw6xmjfi_AI%20SIGNAL-CROP.png"
                  alt="AI Signal Smart Desk"
                  className="w-full max-w-[280px] md:max-w-[320px] h-auto object-contain"
                />
              </div>
            </div>

            {/* Features - Center on mobile */}
            <div className="space-y-6 text-center md:text-left">
              <p className="text-xl md:text-2xl text-[#191919]/80 font-medium mb-8">
                Setiap signal datang dengan:
              </p>
              
              <div className="space-y-4">
                <div className="flex items-start gap-3 justify-center md:justify-start">
                  <div className="w-2 h-2 bg-[#33CCCC] rounded-full mt-3 flex-shrink-0" />
                  <p className="text-lg md:text-xl text-[#191919] font-medium">Entry point yang jelas</p>
                </div>
                <div className="flex items-start gap-3 justify-center md:justify-start">
                  <div className="w-2 h-2 bg-[#33CCCC] rounded-full mt-3 flex-shrink-0" />
                  <p className="text-lg md:text-xl text-[#191919] font-medium">TP1, TP2, TP3 — anda pilih nak secure mana</p>
                </div>
                <div className="flex items-start gap-3 justify-center md:justify-start">
                  <div className="w-2 h-2 bg-[#33CCCC] rounded-full mt-3 flex-shrink-0" />
                  <p className="text-lg md:text-xl text-[#191919] font-medium">Stop loss yang calculated</p>
                </div>
                <div className="flex items-start gap-3 justify-center md:justify-start">
                  <div className="w-2 h-2 bg-[#33CCCC] rounded-full mt-3 flex-shrink-0" />
                  <p className="text-lg md:text-xl text-[#191919] font-medium"><span className="text-[#FF6699] font-bold">Dan sebab kenapa</span> AI suggest trade tu</p>
                </div>
              </div>

              <div className="mt-10 pt-8 border-t border-[#191919]/10">
                <p className="text-lg md:text-xl text-[#191919]/60 font-medium">
                  Bukan "BUY XAUUSD NOW!!!" pastu senyap.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Feature 2: Watchlist - With Border */}
        <div className="mb-12 border-2 border-[#191919]/10 rounded-3xl p-6 md:p-10 lg:p-12 hover:border-[#FF6699]/30 transition-all duration-300">
          <h3 className="text-3xl md:text-4xl lg:text-5xl font-black text-[#191919] text-center mb-12 tracking-tight">
            Watchlist Yang Kerja <span className="text-[#FF6699]">Masa Anda Tidur</span>
          </h3>
          
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Features - Left side on desktop, center on mobile */}
            <div className="order-2 md:order-1 space-y-6 text-center md:text-left">
              <div className="bg-[#191919] rounded-2xl p-6 md:p-8">
                <p className="text-xl md:text-2xl text-[#F8F8F8] font-medium">
                  RSI oversold? MACD cross? Setup forming?
                </p>
                <p className="text-2xl md:text-3xl text-[#FFD760] font-bold mt-4">
                  Alert terus ke phone.
                </p>
              </div>

              <div className="space-y-4 mt-8">
                <p className="text-lg md:text-xl text-[#191919]/70 font-medium">
                  Anda tak perlu stare screen 6 jam.
                </p>
                <p className="text-xl md:text-2xl text-[#191919] font-bold">
                  Pergi main dengan anak. Lepak dengan family.
                </p>
                <p className="text-2xl md:text-3xl text-[#FF6699] font-bold">
                  Bila ada setup — anda tahu.
                </p>
              </div>
            </div>

            {/* Phone Mockup - Watchlist CROP - Bottom padding 0 */}
            <div className="order-1 md:order-2 flex justify-center">
              <div className="border-2 border-[#191919]/10 rounded-3xl pt-4 px-4 pb-0 bg-[#191919]/5 overflow-hidden">
                <img 
                  src="https://customer-assets.emergentagent.com/job_618cd302-26c2-4845-b940-fc1c769b2643/artifacts/y2g6itlp_WATCHLIST-CROP.png"
                  alt="Watchlist Smart Desk"
                  className="w-full max-w-[280px] md:max-w-[320px] h-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Feature 3: Journal - With Border */}
        <div className="border-2 border-[#191919]/10 rounded-3xl p-6 md:p-10 lg:p-12 hover:border-[#FF6699]/30 transition-all duration-300">
          <h3 className="text-3xl md:text-4xl lg:text-5xl font-black text-[#191919] text-center mb-12 tracking-tight">
            Journal Yang Tunjuk <span className="text-[#FF6699]">Siapa Anda Sebenarnya</span>
          </h3>
          
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Phone Mockup - Journal CROP - Bottom padding 0 */}
            <div className="flex justify-center">
              <div className="border-2 border-[#191919]/10 rounded-3xl pt-4 px-4 pb-0 bg-[#191919]/5 overflow-hidden">
                <img 
                  src="https://customer-assets.emergentagent.com/job_618cd302-26c2-4845-b940-fc1c769b2643/artifacts/5lef63tl_JOURNAL-CROP.png"
                  alt="Journal Smart Desk"
                  className="w-full max-w-[280px] md:max-w-[320px] h-auto object-contain"
                />
              </div>
            </div>

            {/* Questions & Content - Center on mobile */}
            <div className="space-y-6 text-center md:text-left">
              <div className="space-y-4">
                <div className="bg-[#191919]/5 rounded-xl p-4 md:p-5 border-l-4 border-[#FFD760]">
                  <p className="text-lg md:text-xl text-[#191919] font-medium italic">
                    "Eh kenapa aku selalu loss hari Jumaat?"
                  </p>
                </div>
                <div className="bg-[#191919]/5 rounded-xl p-4 md:p-5 border-l-4 border-[#FFD760]">
                  <p className="text-lg md:text-xl text-[#191919] font-medium italic">
                    "Kenapa GBPJPY aku selalu kena SL?"
                  </p>
                </div>
                <div className="bg-[#191919]/5 rounded-xl p-4 md:p-5 border-l-4 border-[#FFD760]">
                  <p className="text-lg md:text-xl text-[#191919] font-medium italic">
                    "Bila aku trade time mood REVENGE, win rate aku berapa?"
                  </p>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-[#191919]/10">
                <p className="text-xl md:text-2xl text-[#191919]/80 font-medium mb-6">
                  Semua jawapan ada dalam data <span className="text-[#33CCCC] font-bold">anda sendiri.</span>
                </p>

                <p className="text-lg md:text-xl text-[#191919] font-medium mb-6">
                  Fira track. Fira analyze. Fira tunjuk.
                </p>

                <p className="text-xl md:text-2xl text-[#FF6699] font-bold">
                  Anda decide nak improve atau nak ignore.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="flex justify-center mt-16">
          <a
            href={ctaLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleCTAClick}
            data-testid="theshift-cta-button"
            className="bg-[#FF6699] hover:bg-[#ff4d88] text-white text-lg md:text-xl font-bold px-10 md:px-14 py-4 md:py-5 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
          >
            Claim Access Percuma
          </a>
        </div>
      </div>
    </section>
  );
};

export default TheShiftSection;
